import React from 'react';

const HeaderCell = (props) => {
    const { rowSpan, content, position, rowTitlePosition } = props;

    return (
        <td
            rowSpan={rowSpan}
            bgcolor={rowTitlePosition === position ? 'white' : 'white'}
        >
            {content}
        </td>
    )
};

export default HeaderCell;

